import { render, staticRenderFns } from "./CommentCreate.vue?vue&type=template&id=60d98c16&scoped=true&"
import script from "./CommentCreate.vue?vue&type=script&lang=js&"
export * from "./CommentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d98c16",
  null
  
)

export default component.exports